import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { WaitlistForm } from "@/components/common/WaitlistForm";
import { RiderApplicationForm } from "@/components/common/RiderApplicationForm";
import { MerchantPartnerForm } from "@/components/common/MerchantPartnerForm";
import { cn } from "@/lib/utils";

// Reusable call-to-action button that opens a dialog with the right lead-capture
// form (waitlist / rider / merchant). Submissions are saved to the backend.
export const CtaDialog = ({
  label,
  icon: Icon,
  buttonClassName = "",
  buttonSize = "lg",
  fullWidth = false,
  title,
  eyebrow = "Launching soon",
  description,
  formType = "waitlist",
  source = "website",
  waitlistPrefix,
  waitlistButtonLabel = "Notify me",
  accentIcon: AccentIcon,
  testId,
}) => {
  const [open, setOpen] = useState(false);
  const HeaderIcon = AccentIcon || Icon;
  const prefix = waitlistPrefix || testId;

  const renderForm = () => {
    if (formType === "rider")
      return <RiderApplicationForm testIdPrefix={prefix} source={source} buttonLabel={waitlistButtonLabel} />;
    if (formType === "merchant")
      return <MerchantPartnerForm testIdPrefix={prefix} source={source} buttonLabel={waitlistButtonLabel} />;
    return <WaitlistForm testIdPrefix={prefix} source={source} buttonLabel={waitlistButtonLabel} />;
  };

  return (
    <>
      <Button
        size={buttonSize}
        onClick={() => setOpen(true)}
        data-testid={testId}
        className={cn(fullWidth && "w-full", buttonClassName)}
      >
        {Icon ? <Icon className="h-4 w-4" /> : null}
        {label}
      </Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-md" data-testid={`${testId}-dialog`}>
          <DialogHeader>
            {HeaderIcon ? (
              <div className="mb-2 flex h-12 w-12 items-center justify-center rounded-xl bg-halalgo-green-50 text-halalgo-green-700 ring-1 ring-halalgo-green-200">
                <HeaderIcon className="h-6 w-6" />
              </div>
            ) : null}
            <div className="flex items-center gap-2">
              <DialogTitle className="text-xl">{title}</DialogTitle>
              <Badge className="rounded-md border-transparent bg-halalgo-kraft-500 text-halalgo-ink hover:bg-halalgo-kraft-500">
                {eyebrow}
              </Badge>
            </div>
            <DialogDescription className="pt-1 text-halalgo-ink/70">
              {description}
            </DialogDescription>
          </DialogHeader>

          <div className="mt-2">{renderForm()}</div>
        </DialogContent>
      </Dialog>
    </>
  );
};
